import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const ArrowShrinkFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function ArrowShrinkFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M23.005 8.995h-5.88l5.44-5.44-2.12-2.12-5.45 5.45V.995l-3 3v5.89l-.05.05.05.05v2.01h2.01l.06.06.06-.06h5.87l3.01-3ZM4.005 11.995l-3.01 3h5.89l-5.44 5.44 2.12 2.12 5.43-5.43v5.88l3-3v-8.01h-7.99Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default ArrowShrinkFilled;